/* Carousels: reviews (03b) with arrows + progress bar, and the Trybe video cards (06b) with dots.
   Native scroll-snap swipe; index = card whose left edge is nearest the viewport's left; arrows scroll one card + gap.
   Progress = (index+1)/count; prev disabled at 0, next at the last. Keyboard: arrow keys on the focused viewport. No autoplay. */
(() => {
  const reduce = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(root) {
    if (root.dataset.smCarReady) return;
    root.dataset.smCarReady = '1';
    const vp = root.querySelector('[data-sm-carousel-viewport]');
    if (!vp) return;
    const track = vp.firstElementChild;
    const cards = [...track.children];
    const n = cards.length;
    const prev = root.querySelector('[data-sm-carousel-prev]');
    const next = root.querySelector('[data-sm-carousel-next]');
    const prog = root.querySelector('[data-sm-carousel-progress]');
    const dots = [...root.querySelectorAll('[data-sm-carousel-dot]')];
    let idx = 0;
    const indexNow = () => {
      const left = vp.getBoundingClientRect().left + (parseFloat(getComputedStyle(vp).scrollPaddingLeft) || 0);
      let best = 0, bestD = Infinity;
      cards.forEach((c, i) => { const d = Math.abs(c.getBoundingClientRect().left - left); if (d < bestD) { bestD = d; best = i; } });
      // at the end of the scroll range, the last card counts as active
      if (vp.scrollLeft + vp.clientWidth >= vp.scrollWidth - 2) best = n - 1;
      return best;
    };
    const paint = () => {
      if (prog) prog.style.width = ((idx + 1) / n * 100).toFixed(2) + '%';
      if (prev) { prev.classList.toggle('off', idx === 0); prev.setAttribute('aria-disabled', idx === 0 ? 'true' : 'false'); }
      if (next) { next.classList.toggle('off', idx === n - 1); next.setAttribute('aria-disabled', idx === n - 1 ? 'true' : 'false'); }
      dots.forEach((d, i) => { d.classList.toggle('on', i === idx); d.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
    };
    const goTo = (i) => {
      i = Math.max(0, Math.min(n - 1, i));
      const pad = parseFloat(getComputedStyle(vp).scrollPaddingLeft) || 0;
      const left = vp.scrollLeft + (cards[i].getBoundingClientRect().left - vp.getBoundingClientRect().left) - pad;
      vp.scrollTo({ left, behavior: reduce() ? 'auto' : 'smooth' });
      if (i !== idx) root.dispatchEvent(new CustomEvent('sm:carousel:change', { bubbles: true, detail: { index: i } }));
      idx = i; paint();
    };
    let t;
    vp.addEventListener('scroll', () => { clearTimeout(t); t = setTimeout(() => { const before = idx; idx = indexNow(); paint(); if (idx !== before) root.dispatchEvent(new CustomEvent('sm:carousel:change', { bubbles: true, detail: { index: idx } })); }, 90); }, { passive: true });
    if (prev) prev.addEventListener('click', () => { if (idx > 0) goTo(idx - 1); });
    if (next) next.addEventListener('click', () => { if (idx < n - 1) goTo(idx + 1); });
    dots.forEach((d, i) => d.addEventListener('click', () => goTo(i)));
    vp.addEventListener('keydown', (e) => {
      if (e.target !== vp) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(idx + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(idx - 1); }
    });
    paint();
  }
  const run = () => document.querySelectorAll('[data-sm-carousel]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
